<template>
  <div id="informationDetails">
    <div class="information-content" v-if="!forbidden">
      <div class="information-inner">
        <h1>{{ data.title }}</h1>
        <div class="article-info">
          <ul>
            <li>
              <van-icon class="iconfont" class-prefix="icon" name="activity"></van-icon>
              <span>{{ moment(data.publishdate).format('Y年M月d日') }}</span></li>
            <li>
              <van-icon class="iconfont" class-prefix="icon" name="manage"></van-icon>
              <span>{{ data.tag }}</span></li>
            <li>
              <van-icon class="iconfont" class-prefix="icon" name="yanjing_dakai"></van-icon>
              <span>{{ data.readcount }}</span></li>
            <li>
              <van-icon class="iconfont" class-prefix="icon" name="homepage"></van-icon>
              <span>{{ data.orgname }}</span>
            </li>
          </ul>
          <van-button type="info" size="small" @click="handleFocus(0)" v-if="!focused">关注</van-button>
          <van-button type="danger" size="small" @click="handleFocus(1)" v-else>取消关注</van-button>
        </div>
        <article v-html="data.content" class="panel-intro text-rich" v-image-preview>
        </article>
      </div>
    </div>
    <div class="empty-container" v-else>
      <Error :type="forbidden.type" :desc="forbidden.desc"/>
    </div>
  </div>
</template>
<script>
import {queryCancelFocusOrg, queryFocusOrg, queryServiceNewsDetail} from "@/api/home";
import { Dialog } from 'vant';
import moment from "moment"
import {Toast} from 'vant'
export default {
  name: 'informationDetails',
  components: {},
  props:['newId'],
  data() {
    return {
      forbidden:null,
      focused: false,
      data:{}
    };
  },
  created() {
    this.onLoad();
  },
  methods:{
    onLoad(){
      queryServiceNewsDetail(this.newId).then(resp => {
        if (resp.code == 3060002 || resp.code == 3060002 || resp.code != 200) {
          this.forbidden = {type: 'forbidden', desc: resp.message};
          return;
        }
        this.data = resp.data;
        document.title = this.data.title;
        let orgs = resp.data.attention.orgs
        if (orgs.length <= 0) {
          this.focused = false;
          return;
        } else {
          orgs.forEach(item=>{
            if(item.orgid == this.data.orgid) {
              this.focused = true;
              return
            }
          })
        }
      })
    },
    handleFocus(type){
      if(this.data.orgid){
        if(type === 0){
          queryFocusOrg({orgId: this.data.orgid, orgName: this.data.orgName}).then(resp=>{
            if(resp.code == 3060004 || resp.code != 200){
              Toast(resp.message);
              return;
            }
            Toast('关注部门成功');
            this.focused = true;
          });
        }else{
          Dialog.confirm({
            title: '确认',
            message: '确定要取消关注该部门的公告吗？'
          }).then(() => {
            queryCancelFocusOrg(this.data.orgid).then(resp=>{
              if(resp.code != 200){
                Toast(resp.message);
                return;
              }
              Toast('取消关注部门成功');
              this.focused = false;
            });
          }).catch(() => {
            // on cancel
          });
        }

      }
    },
    moment
  }
}
</script>
<style scoped lang="scss">
@import '~@/assets/css/theme/theme.scss';

.information-content {
  padding: 12px 15px;

  .information-inner {
    padding: 15px;
    border-radius: 6px;
    background: #fff;

    h1 {
      margin-bottom: 20px;
      color: $c333;
      @extend .font18;
    }

    .article-info {
      position: relative;
      margin-bottom: 15px;

      ul {
        padding-right: 65px;
        overflow: hidden;

        li {
          float: left;
          min-width: 50%;
          line-height: 20px;
          margin-bottom: 8px;
          padding: 0 5px;
          box-sizing: border-box;
          @extend .font12;

          i, span {
            float: left;
          }

          i {
            color: #1678ff;
          }

          span {
            margin-left: 5px;
            font-size: $base-fontsize11;
            color: $c999;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            @extend .font11;
          }
        }
      }

      button {
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    article {
      color: $c333;
      @extend .font14;
    }
  }
}
.empty{
  margin-top: 100px;
}
</style>
